import { Divider, Row, Typography } from 'antd';
import React, { Fragment, memo } from 'react';

const { Title } = Typography;

interface IProcedure {
  id: number;
  mimeData: string;
  name: 'Emergency release';
  subStoryLines: ISubStoryLine[];
}

interface ISubStoryLine {
  id: number;
  name: string;
  remark: string;
  mimeData: { mimeDataName: string };
}

interface IProps {
  procedure: IProcedure;
}

export const Procedure: React.FC<IProps> = memo(({ procedure }) => {
  return (
    <>
      {procedure && (
        <>
          <Row>
            <Title level={4}>{procedure.name}</Title>
          </Row>
          {procedure.mimeData && (
            <Row>
              <img alt="" width={600} src={procedure.mimeData} />
            </Row>
          )}
          {procedure.subStoryLines?.map((subStoryLine, index) => {
            return (
              <Fragment key={`${subStoryLine.name}${index}`}>
                <Row>
                  <Title level={5}>
                    {subStoryLine.name} {subStoryLine.remark}
                  </Title>
                </Row>
                {subStoryLine.mimeData?.mimeDataName && (
                  <Row>
                    <img alt="" width={600} src={subStoryLine.mimeData.mimeDataName} />
                  </Row>
                )}
              </Fragment>
            );
          })}
          <Divider />
        </>
      )}
    </>
  );
});
